import { FC, useContext, useEffect, useState } from "react";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepButton from "@material-ui/core/StepButton";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import metamask from "../../assets/images/icons/metamask.svg";
import arrow from "../../assets/images/arrow.svg";
import {
  Box,
  Grid,
  Container,
  useMediaQuery,
  MenuItem,
  StepLabel,
} from "@material-ui/core";

import { useTheme } from "@material-ui/core";
import warningline from "../../assets/images/warningline.svg";
import useStyles from "../Styles/StepperStyles";
import stepperConnectIcon from "../../assets/images/stepperConnectIcon.svg";
import Select from "@material-ui/core/Select";
import { Formik, Form } from "formik";
import WalletContext from "../../store/Wallet/WalletContext";
import SubscriptionContext from "../../store/Subscription/SubscriptionContext";
import AlertContext from "../../store/Alert/AlertContext";
import { useHistory, useParams } from "react-router";
import { validateUserWhitelist } from "../../helpers/validateUser";
import BuyGainModel from "../Modals/BuyGainModel";
import ConfirmationModel from "../Modals/ConfirmationModel";
import { shorter } from "../../utils/web3/formatBalance";
import PoolContext from "../../store/Pool/PoolContext";
import { MdCheckCircle } from "react-icons/md";
import { useAccount } from "wagmi";
import { useWalletConnect } from "../../services/web3/hooks/useWeb3";
import AuthContext from "../../store/Auth/AuthContext";

type HorizontalNonLinearStepperProps = {
    projectData?: (pool: any[]) => void,
    projectChangeEnabled: boolean,
    disableModals: boolean,
    finished?: boolean,
}

const Warning = () => {
  return (
    <img src={warningline} className="img-fluid warningimg" alt="warning" />
  );
};

const Success = () => {
  return (
    <img
      src={stepperConnectIcon}
      className="img-fluid warningimg"
      alt="success"
    />
  );
};

const Icon = () => {
  return <img src={metamask} alt="icon" />;
};

const Arrow = () => {
  return <img src={arrow} alt="gains" />;
};

const INITIAL_FORM_STATE = {
  choose: "",
};

const HorizontalNonLinearStepper: FC<any> = ({
  projectData,
  projectChangeEnabled,
  disableModals,
  finished=false,
}: HorizontalNonLinearStepperProps) => {
  
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));

  let { ids }: any = useParams();

  const { setAlert } = useContext<any>(AlertContext);
  const { getProfileData } = useContext<any>(AuthContext);
  const { lockedGains } = useContext<any>(SubscriptionContext);
  const { gainsBalance, openmodal } = useContext<any>(WalletContext);
  const { livePools: pools, userPledges } = useContext<any>(PoolContext);
  
  const { address } = useAccount();
  const { openConnectModal } = useWalletConnect();

  const steps = getSteps();
  
  const [activeStep, setActiveStep] = useState(0);
  const [pledgeData, setPledgeData] = useState<any>();
  const [project, setProject] = useState(ids);
  const [open, setOpen] = useState(false);

  function getSteps() {
    if (lockedGains && lockedGains >= 1000) {
      return ["Stake GAINS", "KYC", "Apply for Whitelist"];
    } else {
      return ["KYC", "Stake GAINS", "Apply for Whitelist"];
    }
  }
  
  useEffect(() => {
    if (lockedGains && lockedGains >= 1000) {
      if (getProfileData && getProfileData.kycStatus && getProfileData.kycStatus === 'approved') {
        setActiveStep(2);
      } else {
        setActiveStep(1);
      }
    } else {
      if (getProfileData && getProfileData.kycStatus && getProfileData.kycStatus === 'approved') {
        setActiveStep(1);
      } else {
        setActiveStep(0);
      }
    }
  }, [lockedGains, getProfileData]);

  const handleWalletConnect = () => {
    if (!address && openConnectModal) openConnectModal(); 
  }

  const handleChange = (event: any) => {
    setProject(event.target.value);
    history.push(`/lock-tokens/${event.target.value}`);
    localStorage.setItem("poolId", event.target.value);
    setAlert("Project Changed", "success");
  };

  useEffect(() => {
    return () => setActiveStep(-1);
  }, [])

  useEffect(() => {
    if (pools && pools.length > 0) 
    projectData && projectData(pools.filter((pool: any) => pool.id === project));
  }, [pools])

  useEffect(() => {
    if (userPledges) setPledgeData(userPledges);
  }, [userPledges])

  useEffect(() => {
    if (finished) setActiveStep(3);
  }, [finished])

  return (
    <>
      {
        address && (
          <Box textAlign="center" mt={0.5}>
            <Container fixed>
              <>
                {
                  projectChangeEnabled && (
                    <Grid container justifyContent="center">
                      <Grid item md={12} xs={12} className="position-relative">
                        <Formik
                          initialValues={{
                            ...INITIAL_FORM_STATE,
                          }}
                          onSubmit={(values) => {
                            console.log(values);
                          }}
                        >
                          <Form className="icondropdown ">
                            <Select
                              value={project}
                              onChange={handleChange}
                              margin="dense"
                              variant="outlined"
                            >
                              {pools?.map((pool: any) => {
                                if (
                                  validateUserWhitelist(pool.id, pledgeData)
                                ) {
                                  return;
                                } else {
                                  return (
                                    <MenuItem key={pool.id} value={pool.id}>
                                      <img
                                        width="20"
                                        height="20"
                                        style={{
                                          objectFit: "cover",
                                          borderRadius: "50%",
                                        }}
                                        src={pool.image}
                                        className="mr-8"
                                        alt={pool.name}
                                      />{" "}
                                      {pool.name}
                                    </MenuItem>
                                  );
                                }
                              })}
                            </Select>
                            <Box className="textlenght" mt={1}>
                              <Typography
                                align={isActive ? "left" : "center"}
                                variant="subtitle1"
                                className="text-darkslate fw-normal"
                              >
                                Change Project
                              </Typography>
                            </Box>
                          </Form>
                        </Formik>
                      </Grid>
                    </Grid>
                )}
              </>
            </Container>
          </Box>
        )
      }
      <Box className={classes.root}>
        <Container fixed>
          <Grid container>
            <Grid item md={12}>
              <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <Box
                  mr={1}
                  display="flex"
                  flexDirection="column"
                  alignItems="center"
                  className="warningline"
                  position="relative"
                  top={15}
                >
                  <Box>
                    <Button
                      variant="outlined"
                      className="connect-button"
                      color={ address ? "primary" : "secondary" }
                      startIcon={ address ? <Icon /> : "" }
                      onClick={handleWalletConnect} 
                    >
                      {
                        (address)
                          ? 
                            <Typography 
                              color="primary" 
                              variant="caption" 
                              style={{
                                justifyContent: 'center',
                              }}
                            >
                              Connected <MdCheckCircle />
                            </Typography>
                          : "Connect Wallet"
                      }
                    </Button>
                  </Box>
                  <Box mt="12px">
                    <Typography variant="subtitle1" className="color fw-normal">
                      { address && shorter(address) }
                    </Typography>
                  </Box>
                </Box>
                {
                  (address)
                    ? <Success />
                    : <Warning />
                }
                <Box>
                  <Stepper
                    alternativeLabel
                    activeStep={ address ? activeStep : -1 }
                    connector={ <Arrow /> }
                  >
                    {steps.map((label, _) => {
                      return (
                        <Step
                          key={label}
                          className="pointer"
                        >
                          <StepButton>
                            {label}
                          </StepButton>
                        </Step>
                      );
                    })}
                  </Stepper>
                  {
                    openmodal 
                      ? 
                        (
                          <BuyGainModel open={open} setOpen={setOpen} />
                        ) : 
                        (
                          <ConfirmationModel id={ids} open={open} setOpen={setOpen} />
                        )
                  }
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
};

export default HorizontalNonLinearStepper;
